import { z as e } from "zod";
const b = 23, y = 6, C = 255, T = 32, s = (n) => n.split(".").every((t) => Number(t) <= C), a = e.int().positive(), Se = a.brand("UserIdSchema"), he = a.brand("CampaignIdGroupSchema"), le = a.brand("AdGroupIdSchema"), ue = a.brand("CreativeGroupIdSchema"), pe = a.brand("AssetIdSchema"), Ie = a.brand("CampaignVariationIdSchema"), ge = a.brand("CreativeIdSchema"), De = a.brand("LandingIdSchema"), be = a.brand("LandingIdSchema"), ye = a.brand("TargetGroupIdSchema"), Ce = a.brand("CampaignIdSchema"), Te = a.brand("PricingModelIdSchema"), ve = a.brand("CpaAutoRuleIdSchema"), v = e.int().nonnegative().brand("DealTypeIdSchema"), A = e.int().nonnegative().brand("ContentTypeIdSchema"), Ae = a.brand("SpotIdSchema"), P = a.brand("AdTypeIdSchema"), O = a.brand("AdFormatIdSchema"), Pe = a.brand("TargetIdSchema"), Oe = a.brand("BlacklistAutoRuleIdSchema"), Be = a.brand("GoalIdSchema"), ke = a.brand("ArbitrageModelRuleIdSchema"), Ne = a.brand("PaymentTransactionIdSchema"), Re = a.brand("RotatorCampaignIdSchema"), fe = a.brand("PayoutIdSchema"), je = a.brand("SyndicationDomainIdSchema"), B = e.int().min(0).max(b), k = e.int().min(0).max(y), N = e.iso.datetime({ offset: !0 }), we = (n) => N.refine((t) => new Date(t) > /* @__PURE__ */ new Date(), { error: `${n} must be in the future!` }), Me = e.string().trim().min(1), Le = e.string().trim().min(1), _e = e.string().trim().min(1).brand("KeywordsSchema"), Ve = e.int().min(0).max(1e4), xe = e.url().brand("MediaUrlSchema"), Ge = e.url().brand("CustomContentUrlSchema"), Ue = e.string().trim().min(1), R = e.string().trim().min(1), Ee = e.number().nonnegative("bid must not be negative"), Fe = e.number().positive(), r = 0.01, Xe = e.number().min(r, { message: `Budget limit must be at least $${r}` }), $e = e.number().nonnegative(), We = 1e-4, ze = 1e5, He = e.int().positive(), Ke = e.int().min(0).max(100), f = e.ipv4().or(e.ipv6()), j = e.string().regex(/^(\d{1,3}\.){3}\d{1,3}\/(\d{1,2}|(\d{1,3}\.){3}\d{1,3})$/, "Invalid network mask notation").refine((n) => {
  const [t, o] = n.split("/");
  return t === void 0 || o === void 0 || !s(t) ? !1 : o.includes(".") ? s(o) : Number(o) <= T;
}, "Invalid network mask notation"), w = e.union([j, e.cidrv6()]), M = e.string().transform(
  (n) => n.split("-").map((t) => t.trim()).join("-")
).refine(
  (n) => {
    const t = n.split("-");
    return t.length !== 2 ? !1 : e.ipv4().or(e.ipv6()).safeParse(t[0]).success && e.ipv4().or(e.ipv6()).safeParse(t[1]).success;
  },
  { message: "Invalid IP range" }
), L = e.string().trim().min(1).regex(/^.+@.+\..+$/, "Email format is invalid."), _ = e.string().min(1).regex(
  /^[A-Z][A-Za-z0-9() ]+$/,
  "Ad format must start with a capital letter and restricted to letters, digits, parentheses and spaces. See table ad_unit_formats for details."
).brand("DictAdUnitFormatNameSchema"), Ze = L.brand("UsernameSchema"), Ye = e.string().trim().min(1).brand("PasswordSchema"), qe = e.literal("Bearer"), Je = e.string().trim().min(1).brand("AccessTokenSchema"), Qe = e.string().trim().min(1).brand("RefreshTokenSchema"), i = e.int().nonnegative(), c = e.string().trim().min(1), S = e.string().trim().min(2).max(2), m = (n, t) => e.object({
  code: n,
  name: t
}), V = e.number().nonnegative().brand("DictLanguageIdSchema"), h = S.brand("DictIso2CodeSchema"), l = c.brand("DictLanguageNameSchema"), ea = m(
  h,
  l
).readonly(), aa = e.object({
  id: V,
  iso2: h,
  iso3: e.string().trim().min(3).max(3),
  name: l
}), u = e.string().trim().min(2).brand("DictRegionCodeSchema"), x = c.brand("DictRegionNameSchema"), G = m(u, x).readonly(), p = S.brand("DictCountryCodeSchema"), U = c.brand("DictCountryNameSchema"), ta = e.object({
  code: p,
  regionCodes: e.array(u).readonly().nullish()
}), E = m(p, U), na = E.extend({
  regions: e.array(G).readonly().nullish()
}).readonly(), F = i.brand("DictDeviceIdSchema"), X = c.brand("DeviceTypeSchema"), ca = e.object({
  id: F,
  name: X
}).readonly(), I = i.brand("DictOsVersionIdSchema"), $ = c.brand("DictOsVersionNameSchema"), W = e.object({
  id: I,
  name: $
}).readonly(), g = i.brand("DictOsIdSchema"), z = c.brand("DictOsNameSchema"), H = e.object({
  id: g,
  versionIds: I.array().readonly().nullish()
}), K = e.object({
  id: g,
  name: z,
  versions: e.array(W).readonly().nullish()
}).readonly(), D = i.brand("DictOsTypeIdSchema"), Z = c.brand("DictOsTypeNameSchema"), ia = e.object({
  typeId: D,
  oses: H.array().readonly().nullish()
}), oa = e.object({
  typeId: D,
  typeName: Z,
  oses: e.array(K).readonly().nullish()
}).readonly(), Y = i.brand("DictBrowserIdSchema"), q = c.brand("DictBrowserTypeSchema"), ma = e.object({
  id: Y,
  name: q
}).readonly(), J = i.brand("DictBlacklistStatusIdSchema"), Q = c.brand("DictBlacklistStatusNameSchema"), sa = e.object({
  id: J,
  name: Q
}).readonly(), ee = i.brand("DictBlacklistBanTypeIdSchema"), ae = c.brand("DictBlacklistBanTypeNameSchema"), ra = e.object({
  id: ee,
  name: ae,
  // Machine-readable discriminator of the ban flavour ('default', 'ip', 'fraud', 'domain', ...)
  code: e.string().trim().min(1).nullable()
}).readonly(), te = i.brand("DictBlacklistConditionParamIdSchema"), ne = c.brand(
  "DictBlacklistConditionParamNameSchema"
), da = e.object({
  id: te,
  name: ne
}).readonly(), d = e.string().trim().min(1).brand("DictCategoryIdSchema"), ce = e.number().nonnegative().brand("DictCategoryExtIdSchema"), Sa = e.object({
  id: d,
  name: e.string().trim().min(1),
  idParent: d.nullish(),
  extId: ce.nullish()
}), ha = e.union([w, M, f]), ie = e.object({
  day: k,
  hours: e.array(B).readonly()
}).readonly(), la = e.object({
  days: e.array(ie).min(1).readonly(),
  timezone: e.string().trim().min(3)
}).readonly(), ua = e.enum(["enabled", "disabled"]), pa = e.enum([
  "Image",
  // 1
  "Video"
  // 2
]), Ia = e.enum([
  "Animated",
  // 1
  "Static"
  // 2
]), oe = e.enum(["Reviewing", "Approved", "Rejected"]), ga = e.enum([...oe.options, "Incompleted"]), Da = e.enum(["even", "fast"]), ba = e.enum(["Hidden", "Active", "Rejected", "Reviewing", "Stopped", "Paused"]), me = e.enum([
  "CampaignDealType_None",
  "CampaignDealType_SSP",
  "CampaignDealType_DIRECT",
  "CampaignDealType_ALL"
]), ya = e.enum([
  "AssetApproved",
  "AssetRejected",
  "AssetInReview",
  "NoAssets",
  "WaitingAction"
]), Ca = e.enum(["CPM", "CPC", "CPV", "CPA", "DCPM", "MXDCPM"]), se = e.enum([
  "Banner",
  "Video",
  "Push",
  "Popunder",
  "Native",
  "Interstitial",
  "Audio",
  "VideoSlider",
  "Link",
  "Vast",
  "OutstreamVideo",
  "Multispot",
  "InPage"
]), Ta = e.enum(["Default", "No referrer", "Origin"]), re = e.object({
  id: O,
  name: _
}).readonly(), va = e.object({
  id: P,
  name: se,
  formats: e.array(re).optional()
}).readonly(), Aa = e.object({
  id: v,
  priority: me,
  description: e.string().nullable()
}).readonly(), Pa = e.object({
  id: A,
  name: R
}).readonly();
export {
  Je as AccessTokenSchema,
  O as AdFormatIdSchema,
  _ as AdFormatSchema,
  le as AdGroupIdSchema,
  P as AdTypeIdSchema,
  se as AdTypeSchema,
  ke as ArbitrageModelRuleIdSchema,
  pe as AssetIdSchema,
  ga as AssetStatusSchema,
  r as BUDGET_LIMIT_MIN,
  qe as BearerTokenTypeSchema,
  Ee as BidSchema,
  Oe as BlacklistAutoRuleIdSchema,
  Xe as BudgetLimitInputSchema,
  Fe as BudgetLimitSchema,
  v as CampaignDealTypeIdSchema,
  me as CampaignDealTypeSchema,
  he as CampaignGroupIdSchema,
  Ce as CampaignIdSchema,
  ya as CampaignStatusChangeReasonSchema,
  ba as CampaignStatusSchema,
  Ie as CampaignVariationIdSchema,
  Ta as ClickRedirectTypeSchema,
  A as ContentTypeIdSchema,
  R as ContentTypeNameSchema,
  ve as CpaAutoRuleIdSchema,
  ue as CreativeGroupIdSchema,
  ge as CreativeIdSchema,
  pa as CreativeTypeSchema,
  Ve as CreativeVariationWeightSchema,
  Ue as CustomContentSchema,
  Ge as CustomContentUrlSchema,
  N as DateTimeSchema,
  k as DayOfWeekSchema,
  ie as DayScheduleSchema,
  Da as DeliverySchema,
  X as DeviceTypeSchema,
  re as DictAdUnitFormatOutputSchema,
  va as DictAdUnitTypesOutputSchema,
  ee as DictBlacklistBanTypeIdSchema,
  ae as DictBlacklistBanTypeNameSchema,
  ra as DictBlacklistBanTypeSchema,
  te as DictBlacklistConditionParamIdSchema,
  ne as DictBlacklistConditionParamNameSchema,
  da as DictBlacklistConditionParamSchema,
  J as DictBlacklistStatusIdSchema,
  Q as DictBlacklistStatusNameSchema,
  sa as DictBlacklistStatusSchema,
  Y as DictBrowserIdSchema,
  ma as DictBrowserSchema,
  q as DictBrowserTypeSchema,
  ce as DictCategoryExtIdSchema,
  d as DictCategoryIdSchema,
  Sa as DictCategorySchema,
  Pa as DictContentTypeOutputSchema,
  p as DictCountryCodeSchema,
  U as DictCountryNameSchema,
  E as DictCountryOutputSchema,
  Aa as DictDealTypeOutputSchema,
  F as DictDeviceIdSchema,
  ca as DictDeviceSchema,
  ta as DictGeoInputSchema,
  na as DictGeoOutputSchema,
  h as DictLanguageCodeSchema,
  V as DictLanguageIdSchema,
  l as DictLanguageNameSchema,
  aa as DictLanguageOutputSchema,
  ia as DictOSTypeInputSchema,
  oa as DictOSTypeOutputSchema,
  g as DictOsIdSchema,
  H as DictOsInputSchema,
  z as DictOsNameSchema,
  K as DictOsOutputSchema,
  D as DictOsTypeIdSchema,
  Z as DictOsTypeNameSchema,
  I as DictOsVersionIdSchema,
  $ as DictOsVersionNameSchema,
  u as DictRegionCodeSchema,
  x as DictRegionNameSchema,
  G as DictRegionOutputSchema,
  ea as DimensionLanguageOutputSchema,
  Le as DomainNameSchema,
  L as EmailSchema,
  Me as FilenameSchema,
  Be as GoalIdSchema,
  B as HourSchema,
  f as IPAddressSchema,
  w as IPNetworkSchema,
  M as IPRangeSchema,
  ha as IPSelectorSchema,
  Ia as ImageTypeSchema,
  _e as KeywordsSchema,
  be as LandingGroupIdSchema,
  De as LandingIdSchema,
  xe as MediaUrlSchema,
  a as NumericIdSchema,
  ua as OnOffSchema,
  ze as PRICE_MAX,
  We as PRICE_MIN,
  Ye as PasswordSchema,
  Ne as PaymentTransactionIdSchema,
  fe as PayoutIdSchema,
  Ke as PercentSchema,
  Te as PricingModelIdSchema,
  Ca as PricingRuleModelSchema,
  Qe as RefreshTokenSchema,
  oe as ReviewStatusSchema,
  Re as RotatorCampaignIdSchema,
  Ae as SpotIdSchema,
  $e as StoredBudgetLimitSchema,
  je as SyndicationDomainIdSchema,
  ye as TargetGroupIdSchema,
  Pe as TargetIdSchema,
  He as TrafficLimitSchema,
  Se as UserIdSchema,
  Ze as UsernameSchema,
  la as WeekScheduleSchema,
  m as buildDictOutputSchema,
  we as futureDateSchema
};
//# sourceMappingURL=schemas.js.map
